import React from 'react';

import { AutoPostFileUploader } from './FileUploader';
import Model from './Model';

const GameSoundtrackFields = ({ stage, change, ...props }) => {
	const silence = stage?.silence ?? false;

	if(silence !== false) return null;

	return (
		<Model model={stage} change={change}>
			<AutoPostFileUploader
				name='game_soundtrack'
				auto_type='stage_mp3'
				file={stage?.full_game_soundtrack}
				auto_url={`/promotions/auto_img/${stage.promotion_id}/`}
				_max_weight={2} //MB
				_class={{ size:60 }}
				file_type={['audio']}
			>Background music</AutoPostFileUploader>
		</Model>
	)
};

export default GameSoundtrackFields;